var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.metadata.value),expression:"metadata.value"}],staticStyle:{"width":"70%","padding":"5px"},attrs:{"type":"text"},domProps:{"value":(_vm.metadata.value)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.metadata, "value", $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }